var map = {
	"./Comparison.svg": "gchp",
	"./PCA.svg": "TZOX",
	"./Venn.svg": "EjqS",
	"./analysis.svg": "/tUJ",
	"./bar.svg": "BUXY",
	"./bigData.svg": "WvwW",
	"./bigData1.svg": "SWLv",
	"./boxplot.svg": "ud6N",
	"./complete.svg": "PGk/",
	"./correlation.svg": "0dqo",
	"./data1.svg": "GH/s",
	"./data2.svg": "AnQu",
	"./dna.svg": "BFbE",
	"./download.svg": "+H2/",
	"./error.svg": "KCO8",
	"./experiment.svg": "QdcW",
	"./heatmap.svg": "LFFF",
	"./informatic.svg": "qKZy",
	"./jump.svg": "ZeDN",
	"./load.svg": "u7Bn",
	"./loadRoad.svg": "vz5g",
	"./loading.svg": "NM7p",
	"./message.svg": "G2zY",
	"./meteor.svg": "7V1O",
	"./pause.svg": "mQwT",
	"./proccessing.svg": "Wcjg",
	"./process.svg": "e4hK",
	"./processBar.svg": "aD0r",
	"./processLine.svg": "J3aB",
	"./processing1.svg": "B6YD",
	"./project.svg": "6CSd",
	"./project1.svg": "sTj0",
	"./quant.svg": "/uaM",
	"./queue.svg": "5ou9",
	"./queue1.svg": "SER0",
	"./reagent.svg": "u6py",
	"./reload.svg": "noPE",
	"./sample.svg": "E87q",
	"./spaceship.svg": "WIBi",
	"./testIcon.svg": "BOq7",
	"./userimg.svg": "L89S",
	"./waitting.svg": "zHT9",
	"./waitting1.svg": "bRzJ",
	"./waitting2.svg": "sO3H",
	"./worldcloud.svg": "HUk9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 148